import { ShiftParameters } from "./ShiftParameters";

export const INITIAL_VALUES: ShiftParameters = {
	PatternStart: new Date(),
	ShiftCodes: "",
	Crews: "",
	User: "",
	PatternDays: 5,
	CrewRotation: "",
	Comments: "",
	CanEdit: false,
	ShiftsPerDay: 1,
	NumberOfCrews: 1,
};
